import { FunctionComponent } from 'react';
import { useIntl } from 'react-intl';
import { Toast } from '../../context/Toast/ToastContext.tsx';
import { CheckMark, ErrorIcon } from '../Icons.tsx';
import './Toasts.css';

interface ToastsProps {
  toasts: Toast[];
  onClose: (id: string) => void;
}

const Toasts: FunctionComponent<ToastsProps> = ({ toasts, onClose }) => {
  const intl = useIntl();
  const getIcon = (type: Toast['type']) => {
    if (type === 'success') return <CheckMark />;
    return <ErrorIcon />;
  };

  return (
    <div className="toast-container">
      {toasts.map((t) => (
        <div
          className={`toast-item ${t.type === 'success' ? 'toast-success' : 'toast-error'}`}
          key={t.id}
          aria-live="assertive"
          role="alert"
        >
          {getIcon(t.type)}
          <span className="toast-message">{t.message}</span>
          <button
            className="toast-remove"
            onClick={() => onClose(t.id)}
            aria-label={intl.formatMessage({ id: 'toast.closeButton' })}
          >
            ×
          </button>
        </div>
      ))}
    </div>
  );
};

export default Toasts;
